import type { UploadFileData } from '../components/Application'
import { ApiStudentRequest, request } from '../utils'
import { useAuthMutation } from './auth'
import { GetPassport } from './useGetPassport'
import { useS3Upload } from './useS3Upload'

export function useUploadPassport() {
  const { s3UploadAsync } = useS3Upload()

  const { isPending, mutate } = useAuthMutation(async (passportDocument: UploadFileData) => {
    const response = await CreatePassport(passportDocument)
    const passportUpload = response.data.meta.files[passportDocument.fileName].upload

    await s3UploadAsync({
      file: passportDocument.file,
      url: passportUpload.url,
      fields: passportUpload.fields,
    })

    return await GetPassport(response.data.id)
  })

  return {
    isUploadingPassport: isPending,
    uploadPassport: mutate,
  }
}

type RawUploadPassportResponse = {
  data: {
    id: string
    type: 'passport'
    meta: {
      files: Record<
        string,
        {
          upload: {
            url: string
            fields: Record<string, any>
          }
        }
      >
    }
  }
}

async function CreatePassport(passportDocument: UploadFileData) {
  return request<RawUploadPassportResponse>(
    new ApiStudentRequest('/documents/passports', {
      method: 'POST',
      body: {
        data: {
          type: 'passport',
          attributes: {
            contentType: passportDocument.contentType,
            fileName: passportDocument.fileName,
          },
        },
      },
    }),
    {
      isExpectedResponse: (res): res is RawUploadPassportResponse => res as boolean,
    },
  )
}
